// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.icon[data-v-711e9bd6] {\n\t/* margin-right: 0.3em; */\n}\n", ""]);
// Exports
module.exports = exports;
